export class WeakRefSet {
    #set = new Set();
    add(value) { this.#set.add(new WeakRef(value)); }
    forEach(callback) {
        for (const weakRef of this.#set) {
            const value = weakRef.deref();
            if (value === undefined) {
                this.#set.delete(weakRef);
            }
            else {
                callback(value);
            }
        }
    }
    count() {
        let count = 0;
        for (const weakRef of this.#set) {
            if (weakRef.deref() === undefined) {
                this.#set.delete(weakRef);
            }
            else {
                count++;
            }
        }
        return count;
    }
    clear() { this.#set.clear(); }
}
